<div class="offer-bottom-popup">
  <div>
    <ion-card>
      <ion-card-header class="ion-text-center">
        <ion-card-subtitle>
            <ion-icon name="close-outline" (click)="close(false)" class="--cross"></ion-icon>
        </ion-card-subtitle>
      </ion-card-header>

      <ion-card-content>
        <ion-row><ion-col class="ion-text-left">
          <span class="--title">Add food items for calorie counting</span>
        </ion-col></ion-row>
        <ion-row>
          <ion-col class="ion-text-left" style="font-weight: 500;padding: 10px 5px;">
            <span style="position: relative;
            top: -5px;">Select Slot</span>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col class="ion-text-center green-msg">
            <ion-list>
              <ion-radio-group mode="md" name="radio-group" (ionChange)="radioGroupChange($event)" #radioGroup>
              <ion-item *ngFor="let slot of foodSlots;let i=index;">
                <ion-label>
                  <h2>{{slot.name}}</h2>
                </ion-label>
                <ion-radio slot="end" style="--color-checked:#01A3A4"  [name]="slot.name" [value]="slot.value" checked="{{slot?.isSelected}}"></ion-radio>
              </ion-item>
            </ion-radio-group>
            </ion-list>
          </ion-col>
        </ion-row>

        <ion-row class="text-center" style="margin: 15px 0;">
            <ion-col>
            <ion-button expand="full"  shape="round" (click)="addFood()" style="--background: #01A3A4;">
              Add
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-card-content>
    </ion-card>
  </div>
</div>